import React from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { List, FilterForm, Datagrid } from "components/list"; 
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";
import { TextInput, DateInput } from "components/input";
import { TextField, ChoiceDisplayField } from "components/field";
import { FreeTrialStatusChoices } from "./utils";
import linkToRecordByReplaceId from "util/linkToRecordByReplaceId";
import { freeTrialEditFrontPath } from "./urls";
import { SORT_ASC } from 'reducers/resource/list/queryReducer';

export const FreeTrialFilter = (props) => (
  <FilterForm name="free_trial_search" {...props}>
    <DateInput label="Expire From" source="expire_from" />
    <DateInput label="Expire To" source="expire_to" />
    <TextInput label="Owner Mobile" source="owner_mobile" />
    <TextInput label="Shop ID" source="shop_id" />
  </FilterForm>
);

const options = {
  shop_id: {
    showName: "SHOP ID",
  },
  owner_mobile: {
    showName: "OWNER MOBILE",
  },
  shop_name: {
    showName: "SHOP NAME",
  },
  start_time: {
    showName: "FREE TRIAL START DATE",
  },
  end_time: {
    showName: "FREE TRIAL EXPIRY DATE",
  },
  overdue_status: {
    showName: "OVERDUE STATUS",
  },
};

const listActionOptions = {
  hasExport: true,
  exportFileName: "free_trial_data.csv",
  exportHeaders: Object.keys(options).map((k) => {
    return options[k].showName;
  }),
  exportSources: Object.keys(options),
  exportSourcesTransportMap: {
    start_time: (val)=>{
      return val > 0 ? dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    end_time: (val)=>{
      return val > 0 ? dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    overdue_status: (val)=> {
      return FreeTrialStatusChoices[val] || '';
    }

  }
};

function FreeTrialEditButton({ record = {} }) {
  const disabled = !record["can_edit"];
  return (
    <FlatButton
      primary
      label="EDIT"
      disabled={disabled}
      icon={<ContentCreate />}
      containerElement={
        disabled ? <span/> : (
          <Link
            to={linkToRecordByReplaceId(freeTrialEditFrontPath, record.id)}
          />
        )
      }
      style={{ overflow: "inherit" }}
    />
  );
}

function TimeStampToTextField({ record={}, source, label, format='YYYY-MM-DD HH:mm:ss', emptyPlaceholder='' }) {
  const newRecord = {[source]: record[source] > 0 ? dayjs(record[source] * 1000).format(format) : emptyPlaceholder};
  return <TextField record={newRecord} source={source} label={label} showTime={true}/>
}

function checkCanAutoLoad(filterValues) {
  return filterValues && Object.keys(filterValues).length > 0;
}

export const FreeTrialList = (props) => {
  return (
  <List {...listActionOptions} {...props} checkCanAutoLoad={checkCanAutoLoad} sort ={ {field: 'shop_id',order: SORT_ASC,}} filters={<FreeTrialFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="shop_id" label="SHOP ID"/>
      <TextField source="owner_mobile" label="OWNER MOBILE"/>
      <TextField source="shop_name" label="SHOP NAME"/>
      <TimeStampToTextField source="start_time" label="FREE TRIAL START DATE" showTime={true}/>
      <TimeStampToTextField source="end_time" label="FREE TRIAL EXPIRY DATE" showTime={true}/>
      <ChoiceDisplayField source="overdue_status" label="OVERDUE STATUS" choiceName={FreeTrialStatusChoices} />
      <FreeTrialEditButton label="EDIT" />
    </Datagrid>
  </List>
  );
}




// WEBPACK FOOTER //
// ./src/routes/subscription/FreeTrialList.js